// AdTraction requires their tracking script to be loaded on every page,
// loaded once globally here so purchase tracking (see useAdTractionConversion)
// only needs to populate window.ADT.Tag and call doEvent().
export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const script = document.createElement('script');
    script.src = 'https://id.ullmax.com/jsTag?ap=1954028297';
    script.type = 'text/javascript';
    script.defer = true;
    document.head.appendChild(script);
  }
});
